import { render, staticRenderFns } from "./sup_list.vue?vue&type=template&id=3afe7084&scoped=true&"
import script from "./sup_list.vue?vue&type=script&lang=js&"
export * from "./sup_list.vue?vue&type=script&lang=js&"
import style0 from "./sup_list.vue?vue&type=style&index=0&id=3afe7084&scoped=true&lang=less&"
import style1 from "./sup_list.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afe7084",
  null
  
)

export default component.exports